import { Typography } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { StatusIndicator } from 'components/molecules/status-indicator';
import { CellRendererParams } from './types';

const { Paragraph: AntParagraph } = Typography;
const SingleLineLabel = styled(AntParagraph).attrs({
  ellipsis: { rows: 1, tooltip: true },
})`
  margin-bottom: 0;
  color: inherit;
  width: 100%;
`;
const Wrapper = styled.div`
  display: flex;
  gap: var(--spacing-04);
  padding-right: var(--spacing-03);
`;

export const TaskNameRenderer: FC<CellRendererParams> = ({ data }) => {
  return (
    <Wrapper>
      <StatusIndicator
        status={{
          label: 'To do',
          group: 1,
          color: 'blue',
        }}
      />
      <SingleLineLabel>{data.taskName}</SingleLineLabel>
    </Wrapper>
  );
};
